import Cookies from 'js-cookie';

const backendHost = Cookies.get('backendHost');

const BaseApi = backendHost
  ? backendHost
  : process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : (
      window.location.href.startsWith('https://grc.ua') ||
      window.location.href.startsWith('https://www.grc.ua')
    )
      ? 'https://grc.ua/api'
      : window.location.href.startsWith('https://test19742.grc.ua/')
        ? 'https://test19742.grc.ua/api'
        : 'https://grc.net.ua/api';

export default BaseApi;
